import pushEventAddToCartRental from '#/local/service/dataLayer/pushEventAddToCartRental'
import searchReportRental from '#/local/service/searchReport/rental'

import { redrawSnippets } from '#/local/service'

import type { AddToCartRentalAfter } from '#/global/types'

const addToCartRentalAfter = (event: CustomEvent<AddToCartRentalAfter>) => {
    if (event.detail.isSuccess) {
        redrawSnippets()
        pushEventAddToCartRental(event.detail.product, event.detail.quantitySales)
        searchReportRental(event.detail.product.groupCode)
    }
}
export default addToCartRentalAfter
